import { BaseEntity } from "yt-ng-framework";

export class DonosEkranskaKarticaKomitenata extends BaseEntity{

    constructor(){
        super();
    }

    DonosDuguje: number;
    DonosPotrazuje: number;
    DonosUkupno: number;

    Deserialize(input: any){
        this.DonosDuguje = input.DonosDuguje;
        this.DonosPotrazuje = input.DonosPotrazuje;
        this.DonosUkupno = input.DonosUkupno;
        return this;
    }

    Serialize(input: DonosEkranskaKarticaKomitenata): {} {
        return input;
    }
}